import { CoveoSearchBox } from "@dcl-ue/coveo-search";
export var rehydrator = CoveoSearchBox.rehydrator;
export default rehydrator;